import type { TFunction } from "i18next";

import type { Document } from "@/api/rest/models/document";
import type { ApiChatMessage, WarrantyFlowCtaPayload } from "@/api/rest/services/chatService.ts";

export interface ChatMessageItem {
  message: string;
  isResponse: boolean;
  linkedDocuments: Document[];
  warrantyCta?: WarrantyFlowCtaPayload;
}

// Helper to map component state history to API format
export const mapChatHistoryToApi = (history: ChatMessageItem[]): ApiChatMessage[] => {
  return history.map((item) => ({
    role: item.isResponse ? "assistant" : "user",
    content: item.message,
  }));
};

// "No" to the forward-to-developer offer always gets the same reply, so it needs no model call.
export const appendEscalationDeclined = (history: ChatMessageItem[], t: TFunction): ChatMessageItem[] => [
  ...history,
  { message: t("chat.escalateNo"), isResponse: false, linkedDocuments: [] },
  { message: t("chat.escalateNoReply"), isResponse: true, linkedDocuments: [] },
];
